import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Request } from '../../models/Request/request.model';
import { AuthenService } from '../../services/authen.service';
@Component({
    selector: 'request-new',
    templateUrl: './request-new.html',
})
export class RequestNewComponent implements OnInit {
    @ViewChild('tab') tab: any;
    @ViewChild('tabDetail') tabDetail: any;
    @ViewChild('tabDetailHS') tabDetailHS: any;
    id: number = 0;
    edit: number = 2;
    requestCode: string = '';
    request: Request = new Request();
    groupUserCode: string = "";
    constructor(private router: Router, public auth: AuthenService) {
        console.log('New tender');
        this.groupUserCode = this.auth.GroupUserCode;
    }

    ngOnInit() {

        this.groupUserCode = this.auth.GroupUserCode;
    }

    onCreated(e: any) {
        if (this.groupUserCode == "HS")
        {
            this.tabDetailHS.startInit();
           
        } else {
            this.tabDetail.startInit();
        }
        
    }

    onChangedData(evt: any) {
        var requestSrc = this.groupUserCode == "HS" ? "internal" : "external";
        if (evt.Msg == 'SetEditMode') {
            this.router.navigate(['/request-prop', this.request.ID, this.request.Requestcode, 1, requestSrc, 0]);
        }
    }
}
